import { createAccommodationDetailsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useAccommodationDetailsQuery = createAccommodationDetailsQuery(HTTP_CONFIG.API.Consumer.url)
